import { connect } from 'react-redux'
import actions from 'actions/users'
import Component from 'components/ForgotPassword'

export default connect(null, { resetPassword: actions.resetPassword })(Component)
